<template>
	<div>
		<v-text-field
			placeholder="Paieška"
			single-line
			dense
			hide-details
			v-model="term"
		></v-text-field>
		<div class="d-lg-flex mt-3">
			<div class="flex-grow-1 justify-end mr-2"><slot></slot></div>
			<v-container align-center class="d-flex flex-row-reverse pa-0" v-if="filterType">
				<v-checkbox
					label="Interaktyvūs atlasai"
					dense
					v-model="interactiveAtlases"
					hide-details
					class="mt-0"
				></v-checkbox>
				<v-checkbox
					label="Atlasai, skirti spausdinimui"
					dense
					v-model="printableAtlases"
					hide-details
					class="mt-0 mr-3"
				></v-checkbox>
			</v-container>
			<div v-if="sortable" class="d-flex flex-column sortable-widget body-2">
				<div>
					<v-btn
						icon
						v-on:click="sortableExpanded = !sortableExpanded"
						small
					>
						<template v-if="sortableExpanded">
							<v-icon title="Suskleisti">mdi-menu-up</v-icon>
						</template>
						<template v-else>
							<v-icon title="Išskleisti">mdi-menu-down</v-icon>
						</template>
					</v-btn>
					<span class="font-weight-bold">Rikiuoti pagal</span>
				</div>
				<v-expand-transition>
					<v-card
						v-show="sortableExpanded"
						flat
						class="pa-0"
					>
						<div class="d-flex flex-column ml-7">
							<ul class="ma-0 pa-0">
								<template
									v-for="(item, i) in sortTypes"
								>
									<li class="mb-1" :key="i">
										<template v-if="item.type == sortType">
											<span>{{item.title}}</span>
										</template>
										<template v-else>
											<a href="#" v-on:click.stop.prevent="setActiveSortType(item.type)">{{item.title}}</a>
										</template>
									</li>
								</template>
							</ul>
						</div>
					</v-card>
				</v-expand-transition>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data: function(){
			var data = {
				term: "",
				interactiveAtlases: true,
				printableAtlases: true,
				sortableExpanded: false,
				sortType: null,
				sortTypes: [{
					type: "date",
					title: "Sukūrimo datą"
				},{
					type: "edit-date",
					title: "Redagavimo datą"
				},{
					type: "title",
					title: "Pavadinimą"
				},{
					type: "owner",
					title: "Autorių"
				}]
			};
			return data;
		},
		props: {
			list: Array,
			setFilteredList: Function,
			lists: Object,
			setFilteredLists: Function,
			filterType: Boolean,
			sortable: Boolean
		},
		methods: {
			filterList: function(){
				var filteredList = [],
					filteredListInteractive = [],
					filteredListPrintable = [],
					sortType = this.sortType;
				var term = this.term.trim().toLowerCase();
				this.doFilter(term, this.list, filteredList, sortType);
				if (this.lists) {
					this.doFilter(term, this.lists.interactive, filteredListInteractive, sortType);
					this.doFilter(term, this.lists.printable, filteredListPrintable, sortType);
				}
				if (this.setFilteredList) {
					this.setFilteredList(filteredList);
				}
				if (this.setFilteredLists) {
					this.setFilteredLists({
						interactive: filteredListInteractive,
						printable: filteredListPrintable
					});
				}
			},
			doFilter: function(term, list, filteredList, sortType){
				var match;
				if (list) {
					list.forEach(function(listItem){
						if ((listItem.atlasType == "interactive" && this.interactiveAtlases) || (listItem.atlasType == "printable" && this.printableAtlases)) {
							if (term) {
								match = this.match(term, listItem["title"]);
								if (!match) {
									match = this.match(term, listItem["shortDescription"]);
									if (!match) {
										match = this.match(term, listItem["owner"]);
										if (!match) {
											match = this.match(term, listItem["keywords"]);
										}
									}
								}
							} else {
								match = true;
							}
							if (match) {
								filteredList.push(listItem);
							}
						}
					}.bind(this));
					if (sortType) {
						var field;
						if (sortType == "date") {
							field = "createDate";
						} else if (sortType == "title") {
							field = "title";
						} else if (sortType == "owner") {
							field = "owner";
						} else if (sortType == "edit-date") {
							field = "updateDate";
						}
						if (field) {
							var aVal, bVal;
							filteredList.sort(function(a, b){
								aVal = a[field];
								bVal = b[field];
								if (aVal == bVal) {
									return 0;
								}
								if (aVal > bVal) {
									return 1;
								} else {
									return -1;
								}
							});
							if (sortType == "date" || sortType == "edit-date") {
								filteredList.reverse();
							}
						}
					}
				}
			},
			match: function(term, ref){
				var match;
				if (ref) {
					ref = ref.toLowerCase();
					if (ref.indexOf(term) != -1) {
						match = true;
					}
				}
				return match;
			},
			setActiveSortType: function(sortType){
				this.sortType = sortType;
			}
		},
		watch: {
			term: {
				immediate: true,
				handler: function(){
					this.filterList(); // FIXME! Nereikia filtruoti iškart! Daryti kaip gazetteer'io paieškoje: palaukti kažkiek milisekundžių kol baigs vesti frazę!
				}
			},
			interactiveAtlases: {
				handler: function(){
					this.filterList();
				}
			},
			printableAtlases: {
				handler: function(){
					this.filterList();
				}
			},
			sortType: {
				handler: function(){
					this.filterList();
				}
			}
		}
	};
</script>

<style scoped>
	.sortable-widget {
		width: 140px;
	}
	li {
		list-style-type: none;
	}
</style>